'use strict';

angular.module('atex.dam').factory('DamInformerModal',
['$rootScope', '$q', '$modal',
function($rootScope, $q, $modal) {

  return {
    create: function(params) {
      var defaultParams = { actionHeader: 'Initialize dm.desk application...' };

      var syncArgs = _.extend({}, defaultParams, params);
      var syncScope = $rootScope.$new(true);

      syncScope.actionHeader = syncArgs.actionHeader;
      syncScope.progress = '';

      var modal = $modal({
        show: true,
        scope: syncScope,

        template: 'views/dam-info-modal.html',
        modalClass: 'info-modal',

        backdrop: 'static',
        keyboard: false,
        focus: false // ADM-496
      });

      syncScope.destroyModal = function() {
        var onDestroyedDeferred = $q.defer();

        modal.then(function(modalEl) {
          modalEl.on('hidden.bs.modal', function() {
            syncScope.$destroy();
            onDestroyedDeferred.resolve();
          });

          modalEl.modal('hide');
        });

        return onDestroyedDeferred.promise;
      };

      return {
        setProgress: function(percent) {
          syncScope.progress = percent + '%';
        },

        setActionMessage: function(message) {
          syncScope.actionMessage = message;
        },

        destroy: function() {
          return syncScope.destroyModal();
        }
      };
    }
  };

}]);
